export const Marquee = ({ items, reverse, className = "" }) => (
  <div className={`overflow-hidden border-y border-[#1f1f1f] py-6 ${className}`}>
    <div className={`marquee-track ${reverse ? "marquee-track--rev" : ""}`}>
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((it, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-display text-2xl font-extrabold uppercase tracking-tight text-[#e5e5e5]/25 md:px-12 md:text-4xl">
                {it}
              </span>
              <span className="h-[7px] w-[7px] shrink-0 bg-[#d4ff00]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
